import { boot } from 'quasar/wrappers';
import { Cookies } from 'quasar';
import { setCookies } from 'src/services/token';

export default boot(({ ssrContext }) => {
  const cookies = process.env.SERVER
    ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      Cookies.parseSSR(ssrContext)
    : Cookies;

  setCookies(cookies);
});
